// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16eJn","signatureBlock":"Footer_signatureBlock__2aUC8","signature":"Footer_signature__1qpn4"};